import { ReactElement } from "react";
import {
  LiveChatBlock,
  WiseOwlElementIds,
} from "@twiliointernal/e2-commons-shared-definitions";
import { LiveChat } from "@twiliointernal/e2-commons-live-chat";
import { useWiseOwlContext } from "../../../hooks";
import { useSurveyContext } from "@twiliointernal/e2-commons-csat-survey";

interface LiveChatBlockProps {
  block: LiveChatBlock;
}

const LiveChatRenderer = ({ block }: LiveChatBlockProps): ReactElement => {
  // include LiveChat Props here
  const {
    liveChatConfiguration,
    chatId,
    applicationProps: { scrollContainerElementId, ingress },
    handlers: { handleGetChatSummary },
  } = useWiseOwlContext();
  const {
    state: { token, user },
  } = useSurveyContext();
  const { waitingActions, endedActions } = liveChatConfiguration || {};

  const appContainerId =
    scrollContainerElementId || WiseOwlElementIds.WISE_OWL_CHAT_LOG_CONTAINER;

  return (
    <LiveChat
      {...block.values}
      waitingActions={waitingActions}
      endedActions={endedActions}
      element={WiseOwlElementIds.WISE_OWL_LIVE_CHAT_BLOCK}
      appContainerId={appContainerId}
      chatId={chatId}
      ingress={ingress}
      wiseOwlToken={token}
      user={user}
      handleGetChatSummary={handleGetChatSummary}
    />
  );
};

export default LiveChatRenderer;
